var map = {
	"./slideEight.jpg": 9548,
	"./slideFive.jpg": 1588,
	"./slideFour.jpg": 6951,
	"./slideNine.jpg": 2315,
	"./slideOne.jpg": 1672,
	"./slideSeven.jpg": 8693,
	"./slideSix.jpg": 3443,
	"./slideTen.jpg": 5580,
	"./slideThree.jpg": 6017,
	"./slideTwo.jpg": 9581
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1797;